import { ICON_SHAPES } from '@lunary/app-core/icon-shapes'
import type { IconName, IconShape } from '@lunary/app-core/icon-shapes'

const renderShape = (shape: IconShape, i: number) => {
  if (shape.kind === 'path') return <path key={i} d={shape.d} />
  if (shape.kind === 'rect') return <rect key={i} x={shape.x} y={shape.y} width={shape.width} height={shape.height} rx={shape.rx} />
  return <circle key={i} cx={shape.cx} cy={shape.cy} r={shape.r} />
}

type IconProps = { name: IconName; size?: number; stroke?: number; className?: string }

export function Icon({ name, size = 24, stroke = 1.6, className }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {ICON_SHAPES[name].map(renderShape)}
    </svg>
  )
}

export function StarGlyph({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      aria-hidden="true"
    >
      <circle cx="40" cy="54" r="24" fill="currentColor" fillOpacity="0.2" stroke="none" />
      <circle cx="52" cy="50" r="22" strokeOpacity="0.7" />
      <path d="M52 14 L56 46 L88 50 L56 54 L52 86 L48 54 L16 50 L48 46 Z" />
    </svg>
  )
}

export type { IconName }
